import { motion } from "framer-motion";
import { MANIFESTO_CHAPTERS } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { scrollToId } from "@/lib/scroll";

export default function Manifesto() {
  return (
    <section id="a-diocese" className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-5">
          <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">A Diocese</motion.p>
          <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
            Fé Católica.<br />Tradição Anglicana.<br /><span className="text-[#4A0E17]">Missão no Brasil.</span>
          </motion.h2>
          <motion.div variants={fadeUp} className="gold-rule mt-8 w-40" />
          <motion.p variants={fadeUp} className="font-liturgy mt-8 max-w-md text-2xl italic leading-snug text-[#4A0E17]">
            Uma Diocese de fé católica, tradição anglicana e missão no Brasil.
          </motion.p>
          <motion.p variants={fadeUp} className="mt-6 text-base leading-relaxed text-[#1C1917]/70 max-w-md">
            A Diocese Anglicana Católica do Brasil é uma comunidade eclesial de tradição anglicano-católica,
            comprometida com a fé apostólica, a vida sacramental, a missão pastoral e o serviço ao povo de Deus.
          </motion.p>
          <motion.div variants={fadeUp} data-testid="manifesto-abrangencia" className="mt-6 max-w-md border-l-2 border-[#C5A059] bg-[#F4EFE6] p-5">
            <p className="overline-label text-[#4A0E17]">Uma Diocese presente em todo o Brasil</p>
            <p className="mt-2 text-sm leading-relaxed text-[#1C1917]/75">
              A Diocese Anglicana Católica do Brasil — DACB é uma jurisdição eclesiástica de âmbito nacional, integrante da Comunhão Anglicana Livre Internacional. Com Sé Primacial em Esmeraldas/MG, desenvolve sua missão em todo o território brasileiro por meio de suas Prelazias e estruturas pastorais e missionárias.
            </p>
          </motion.div>
          <motion.p variants={fadeUp} className="mt-6 text-base leading-relaxed text-[#1C1917]/70 max-w-md">
            Conheça nossa história, identidade, sucessão apostólica, estrutura canônica, clero, prelazias e
            presença missionária no Brasil.
          </motion.p>
          <motion.p variants={fadeUp} className="mt-6 max-w-md font-liturgy text-lg italic leading-snug text-[#4A0E17]/80">
            «O passado registra nossa caminhada. O portal oficial apresenta quem somos hoje.»
          </motion.p>
          <motion.button
            variants={fadeUp}
            data-testid="manifesto-cta"
            onClick={() => scrollToId("fe-e-sacramentos")}
            className="overline-label mt-10 bg-[#4A0E17] text-[#FBF9F4] px-8 py-4 hover:bg-[#2E070D] transition-colors"
          >
            Saiba mais sobre a Diocese
          </motion.button>
        </motion.div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-7 flex flex-col justify-center">
          {MANIFESTO_CHAPTERS.map((c) => (
            <motion.div
              key={c.number}
              variants={fadeUp}
              data-testid={`manifesto-chapter-${c.number}`}
              className="group grid sm:grid-cols-12 gap-4 sm:gap-8 py-10 border-b border-[#E5DEC9] first:border-t"
            >
              <span className="sm:col-span-3 font-display text-5xl sm:text-6xl font-bold text-[#C5A059]/40 group-hover:text-[#C5A059] transition-colors duration-500">
                {c.number}
              </span>
              <div className="sm:col-span-9">
                <h3 className="font-display text-xl sm:text-2xl font-bold text-[#4A0E17]">{c.title}</h3>
                <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#1C1917]/65">{c.content}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
